import * as Sentry from '@sentry/browser';
import { Breadcrumb } from '@sentry/browser';

import { parseJWT } from './jwtParser';

// Capture an exception, set tags, and send to Sentry
export function captureSentryException(err: Error): void {
  Sentry.configureScope((scope) => {
    const claims = parseJWT();
    if (claims) {
      scope.setTag('uuid', claims.aud[0]);
      scope.setTag('feature_flags', claims.fea.join(', '));
    }
    Sentry.captureException(err);
  });
}

// Redact private message contents to members.
export function filterNewMessageContents(breadcrumb: Breadcrumb): Breadcrumb {
  try {
    const graphqlData = JSON.parse(breadcrumb.message || '{}');
    if (graphqlData.operationName === 'NewMessage') {
      const messageContents = graphqlData.variables?.content;
      if (messageContents) {
        graphqlData.variables.content = '[redacted]';
      }
      breadcrumb.message = JSON.stringify(graphqlData);
    }
  } catch {}
  return breadcrumb;
}
